import { render, staticRenderFns } from "./refundAccountConfig.vue?vue&type=template&id=706d36b9"
import script from "./refundAccountConfig.vue?vue&type=script&lang=js"
export * from "./refundAccountConfig.vue?vue&type=script&lang=js"
import style0 from "./refundAccountConfig.vue?vue&type=style&index=0&id=706d36b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports